import { useEffect, useRef, useState } from "react";

// Autoguardado cada 30 s cuando hay cambios sin guardar. No recarga ni interrumpe la digitación.
// Uso: const { auto, markSaved } = useAutosave({ data, enabled, save });
// - data: objeto actual del formulario (se serializa para detectar cambios)
// - enabled: solo cuando el formulario es editable
// - save: async (data) => void  (debe enviar lo mismo que el guardado manual)
// - markSaved(): llamar tras cargar los datos y tras un guardado manual exitoso
export function useAutosave({ data, enabled, save, intervalMs = 30000 }) {
  const [auto, setAuto] = useState(null); // null | "guardando" | "error" | "HH:MM"
  const savedRef = useRef(null);
  const dataRef = useRef(data);
  dataRef.current = data;

  const markSaved = (value) => {
    const v = value !== undefined ? value : dataRef.current;
    savedRef.current = v == null ? null : JSON.stringify(v);
    setAuto(null);
  };

  useEffect(() => {
    if (!enabled) return undefined;
    const t = setInterval(async () => {
      const actual = dataRef.current;
      if (actual == null || savedRef.current === null) return;
      const snap = JSON.stringify(actual);
      if (snap === savedRef.current) return;
      setAuto("guardando");
      try {
        await save(actual);
        savedRef.current = snap;
        setAuto(new Date().toLocaleTimeString("es-CO", { hour: "2-digit", minute: "2-digit" }));
      } catch {
        setAuto("error");
      }
    }, intervalMs);
    return () => clearInterval(t);
  }, [enabled]); // eslint-disable-line react-hooks/exhaustive-deps

  return { auto, markSaved };
}
